import _objectWithoutProperties from "C:\\Users\\PabloGabriel\\Documents\\Reactors\\RepoOrquesta\\orquesta\\consola\\app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["url"];
import { createTileLayerComponent, updateGridLayer, withPane } from '@react-leaflet/core';
import { TileLayer as LeafletTileLayer } from 'leaflet';
export var TileLayer = createTileLayerComponent(function createTileLayer(_ref, context) {
  var url = _ref.url,
      options = _objectWithoutProperties(_ref, _excluded);

  return {
    instance: new LeafletTileLayer(url, withPane(options, context)),
    context: context
  };
}, updateGridLayer);